import { useState } from "react";
import Icons from "../../assets/icons/index.js";
import Img from "../../assets/img/index.js";
import { Link, useLocation } from "react-router-dom";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai"; // Import hamburger and close icons
import { LogOut } from "../../components/index";
import { ReactSVG } from "react-svg";
const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false); // State for toggling menu

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const [showPopup, setShowPopup] = useState(false);

  const handleContinueClick = () => {
    setShowPopup(true); // Show popup when Continue button is clicked
  };

  const closePopup = () => {
    setShowPopup(false); // Hide popup when close button is clicked
  };
  return (
    <div className="flex relative">
      {/* Hamburger Icon for Mobile */}
      <div className="sm:hidden absolute top-4 left-4 z-50">
        <button onClick={toggleMenu} className="text-secondary text-2xl">
          {isOpen ? (
            <AiOutlineClose />
          ) : (
            <AiOutlineMenu className="text-customBlack" />
          )}
        </button>
      </div>
      {isOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-customBlack opacity-50 z-40"
          onClick={toggleMenu}
        />
      )}
      {/* Sidebar */}
      <div
        className={`w-64 lg:w-72 h-[100vh] text-secondary flex flex-col items-center py-20 justify-start fixed sm:static z-40 transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } sm:translate-x-0 `}
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.88), rgba(0, 0, 0, 0.88)), url(${Img.NavBarImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Logo */}
        <img src={Img.Logoimg} alt="Logo" className="w-24 mb-10 lg:w-32" />

        {/* Navigation Items */}
        <ul className="flex justify-center items-center flex-col gap-10 py-5 w-full text-center">
          <Link to="/">
            <li className="flex items-center gap-4 cursor-pointer">
              <ReactSVG
                src={Icons.HomeIcon}
                beforeInjection={(svg) => {
                  svg.classList.add("w-6", "md:w-8", "h-auto");
                }}
              />
              <span
                className={`relative w-24 flex justify-start font-ralewaySemiBold hover:after:w-full after:bg-primary after:h-[4px] after:rounded-lg after:absolute after:bottom-[-8px] after:left-[-5px] 2xl:after:bottom-[-14px] 2xl:text-[22px] pl-1 sm:pl-2 ${
                  location.pathname === "/" ? "active" : ""
                }`}
              >
                Home
              </span>
            </li>
          </Link>
          <Link to="/profile">
            <li className="flex items-center gap-4 cursor-pointer">
              <ReactSVG
                src={Icons.ProfileIcon}
                beforeInjection={(svg) => {
                  svg.classList.add("w-6", "md:w-8", "h-auto");
                }}
              />
              <span
                className={`relative w-24 flex justify-start font-ralewaySemiBold hover:after:w-full after:bg-primary after:h-[4px] after:rounded-lg after:absolute after:bottom-[-8px] after:left-[-5px] 2xl:after:bottom-[-14px] 2xl:text-[22px] pl-1 sm:pl-2 ${
                  location.pathname === "/profile" ? "active" : ""
                }`}
              >
                Profile
              </span>
            </li>
          </Link>
          <Link to="/status">
            <li className="flex items-center gap-4 cursor-pointer">
              <ReactSVG
                src={Icons.StatusIcon}
                beforeInjection={(svg) => {
                  svg.classList.add("w-6", "md:w-8", "h-auto");
                }}
              />
              <span
                className={`relative w-24 flex justify-start font-ralewaySemiBold hover:after:w-full after:bg-primary after:h-[4px] after:rounded-lg after:absolute after:bottom-[-8px] after:left-[-5px] 2xl:after:bottom-[-14px] 2xl:text-[22px] pl-1 sm:pl-2 ${
                  location.pathname === "/status" ? "active" : ""
                }`}
              >
                Status
              </span>
            </li>
          </Link>
          <li
            className="flex items-center gap-4 cursor-pointer"
            onClick={handleContinueClick}
          >
            <ReactSVG
              src={Icons.LogoutIcon}
              beforeInjection={(svg) => {
                svg.classList.add("w-6", "md:w-8", "h-auto");
              }}
            />
            <span
              className={`relative w-24 flex justify-start font-ralewaySemiBold hover:after:w-full after:bg-primary after:h-[4px] after:rounded-lg after:absolute after:bottom-[-8px] after:left-[-5px] 2xl:after:bottom-[-14px] 2xl:text-[22px] pl-1 sm:pl-2 `}
            >
              Logout
            </span>
          </li>
        </ul>
      </div>
      {showPopup && <LogOut closePopup={closePopup} />}
    </div>
  );
};

export default Navbar;
